import { render } from "./DragSort.vue?vue&type=template&id=be06b7b2"
import script from "./DragSort.vue?vue&type=script&lang=js"
export * from "./DragSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__